import { OptionalFeature } from "../../../../base/domain/drawing";
import { IHisInformationItemDefaultSelectBehavior, HisInformationItemDefaultSelectKinds } from "./IHisInformationItemDefaultSelectBehavior";

export class HisInformationItemDefaultSelectBehavior extends OptionalFeature {
  constructor(
    isEnable: boolean     = false,
    public kind: HisInformationItemDefaultSelectKinds = HisInformationItemDefaultSelectKinds.Top,
  ) {
    super(isEnable);
  }
  
  clone(): HisInformationItemDefaultSelectBehavior {
    return new HisInformationItemDefaultSelectBehavior(this.isEnable, this.kind);
  }

  static from(source: IHisInformationItemDefaultSelectBehavior): HisInformationItemDefaultSelectBehavior {
    return new HisInformationItemDefaultSelectBehavior(source.isEnable, source.kind);
  }

  static to(source: HisInformationItemDefaultSelectBehavior): IHisInformationItemDefaultSelectBehavior {
    return {
      isEnable: source.kind !== HisInformationItemDefaultSelectKinds.None,
      kind: source.kind,
    };
  }
}
